




































import Vue from "vue";

export default Vue.extend({
  name: "Button",
  props: {
    buttonText: {
      type: String,
      default: "APPLY!",
    },
    buttonLink: {
      type: String,
      default: "https://my.deltahacks.com/",
    },
  },
});
